import { SVGAttributes } from "react";

export type SvgProps = SVGAttributes<{}>;

export const propsHelper = (
    width: number,
    height: number,
    props: SvgProps,
    viewBox?: string
): SvgProps => ({
    width: `${width}px`,
    height: `${height}px`,
    viewBox: viewBox || `0 0 ${width} ${height}`,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ...props,
});

/*
Example:

    import React, { FunctionComponent } from 'react';

    import { SvgProps, propsHelper } from 'utils/svgPropsHelper';

    const Icon: FunctionComponent<SvgProps> = props => (
    const { fill = '#ffdc61' } = props;

        <svg fill={fill} {...propsHelper(24, 24, props)}>
            <path
                id="id"
                stroke="none"
                strokeWidth="1"
                fill="white"
                fillRule="evenodd"
                clipRule="evenodd"
                opacity="0.9"
                d="M10.415 9L15 13.584 13.587 15 9 10.415 4.413 15 3 13.584 7.585 9 3 4.416 4.413 3 9 7.585 13.587 3 15 4.416 10.415 9z"
            />
        </svg>
    );

    export default Icon;

    <Icon fill="#04b" />
*/
